import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import { TIME_ZONE_UTC } from '../../constants';
import { FormattedDate } from 'react-intl';
import { ChevronRight } from './fa_icons';
import { archivesURLPath } from '../../utils/date';
import {pickBy, isNumber, isString} from 'lodash';
import { getRelativePath } from '../../utils/url';

const DateLabel = ({ archivesState, timestamp }, { edition_data }) => {
  const isOnYearPage = archivesState.month === null && archivesState.day === null;

  const isDailyDateLabel =
    !isOnYearPage && isNumber(archivesState.month);

  const date = new Date(timestamp);

  const dateProps = pickBy({
    month: 'long',
    day: isDailyDateLabel && 'numeric',
    timeZone: TIME_ZONE_UTC
  }, isString);

  const href = archivesURLPath({
    year: date.getUTCFullYear(),
    month: date.getUTCMonth(),
    day: isDailyDateLabel ? date.getUTCDate() : null
  });

  return (
    <Link to={getRelativePath(href, edition_data)}>
      <div className="date-label">
        <FormattedDate value={timestamp} {...dateProps} />
        <ChevronRight />
      </div>
    </Link>
  );
};

DateLabel.propTypes = {
  archivesState: PropTypes.shape({
    year: PropTypes.number,
    month: PropTypes.number
  }).isRequired,
  timestamp: PropTypes.number.isRequired
};

DateLabel.contextTypes = {
  edition_data: PropTypes.object.isRequired
};

export default DateLabel;
